import { Button, DatePicker, Form, InputNumber } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { FC } from 'react'
import { outputDateFormat } from '../../../../constants/constants'
import {
    requiredDatePickerRules,
    requiredInputNumberRules,
} from '../../../../constants/forms/validation/rules'
import connect from '../../../../helpers/api/connect'
import useErrorModal from '../../../../hooks/api/use-error-modal'
import { useUser } from '../../../../hooks/use-user'
import { useCreateOvertimeMutation } from '../../../../store/api/overtimes-api'

interface FormValues {
    date: Dayjs
    hours: number
}

const AddOvertimeForm: FC = () => {
    const [form] = Form.useForm<FormValues>()
    const user = useUser()
    const [createOvertime, createState] = useCreateOvertimeMutation()

    useErrorModal(createState, 'Ошибка добавления переработки')

    const onFinish = async (values: FormValues) => {
        if (!user) return

        await createOvertime({
            data: {
                date: values.date.format('YYYY-MM-DD'),
                hours: values.hours,
                user: [
                    {
                        created_by_permissions_user: connect(user),
                    },
                ],
            },
        }).unwrap()

        form.resetFields()
        form.setFieldsValue({ date: dayjs() })
    }

    return (
        <Form
            form={form}
            layout='inline'
            onFinish={onFinish}
            initialValues={{ date: dayjs(), hours: undefined }}
        >
            <Form.Item name='date' label='Дата' rules={requiredDatePickerRules}>
                <DatePicker format={outputDateFormat} allowClear={false} />
            </Form.Item>
            <Form.Item name='hours' label='Кол-во часов' rules={requiredInputNumberRules}>
                <InputNumber min={0.5} step={0.5} />
            </Form.Item>
            <Form.Item>
                <Button type='primary' htmlType='submit' loading={createState.isLoading}>
                    Добавить
                </Button>
            </Form.Item>
        </Form>
    )
}

export default AddOvertimeForm
